

































































































































import axios from "axios";
import Document, { DocumentTypes } from "@/models/Document";
import DatePicker from "@/scaffold/DatePicker.vue";
import CountryCombo from "@/scaffold/CountryCombo.vue";
import PublisherCombo from "@/scaffold/PublisherCombo.vue";

import { Vue, Component, Watch, Prop } from "vue-property-decorator";

@Component({
  components: {
    DatePicker,
    CountryCombo,
    PublisherCombo,
  },
})
export default class DocumentForm extends Vue {
  @Prop({ default: () => new Document() }) value!: Document;

  private formValid: boolean = false;
  private grabingFile: boolean = false;
  // private value: Document = new Document();

  // computed
  // -------------------------------------------------------------------
  get rules() {
    return {
      name: [
        (v: any) => !!v || "Name is required",
        (v: any) =>
          (v && v.length > 10) || "Name must be more than 10 characters",
      ],
      publication_date: [(v: any) => !!v || "Publication date is required"],
      document_type: [(v: any) => !!v || "Document type is required"],
    };
  }

  get confidentialIcon() {
    return this.value.confidential ? "visibility_off" : "visibility";
  }

  get documentTypes() {
    return DocumentTypes;
  }

  validateForm() {
    // @ts-ignore
    if (this.$refs.form.validate()) {
      this.$toast.success("OK!");
    }
  }
}
